import useNextAssessmentBtn from './useNextAssessmentBtn'
import useGetAssessmentDefOptions from './useGetAssessmentDefOptions'

export default { useNextAssessmentBtn, useGetAssessmentDefOptions }